import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './000c42ca305291142266f5779267d2cd1f0ecd948ac70fc4562b87a43c07d288.cfe-internal.js';
import '../Input/8b306eed80472bc167488d029758903f189ea21b58685c7d85ad4a1de9637088.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import { useComboboxContext } from './b31cf09859637ddcb4d1a4a83c806ba39869aadedd96320b532d4c7939067785.cfe-internal.js';
import { useFormFieldControl } from '../FormField/f390dafefe74ba07f7da711a77443b7b51d96a6ad1aee47361fd1804064e9ba7.cfe-internal.js';
import Input from '../Input/0313aac0a73c29ca9b860be5ca5b212107cd810318bb0b89176cc766dbf84b47.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';
import wrapEvent from '../../utils/wrapEvent/e6437ee06b490c01a1330c8f2f370768104fbf0b8f6557d196331cda5427061b.cfe-internal.js';

var _excluded = ["className", "defaultValue", "disabled", "full", "invalid", "onBlur", "onFocus", "onKeyDown", "onMouseDown", "onClick", "value", "autoComplete", "aria-label", "aria-labelledby"];
var ComboboxInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    defaultValue = _ref.defaultValue,
    externalDisabled = _ref.disabled,
    _ref$full = _ref.full,
    full = _ref$full === void 0 ? true : _ref$full,
    externalInvalid = _ref.invalid,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    onKeyDown = _ref.onKeyDown,
    _onMouseDown = _ref.onMouseDown,
    _onClick = _ref.onClick,
    value = _ref.value,
    _ref$autoComplete = _ref.autoComplete,
    autoComplete = _ref$autoComplete === void 0 ? 'off' : _ref$autoComplete,
    ariaLabelFromProps = _ref['aria-label'],
    ariaLabelledbyFromProps = _ref['aria-labelledby'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useComboboxContext = useComboboxContext(),
    setIsOpen = _useComboboxContext.setIsOpen,
    isAriaExpanded = _useComboboxContext.isAriaExpanded,
    setIsAriaExpanded = _useComboboxContext.setIsAriaExpanded,
    inputValue = _useComboboxContext.inputValue,
    handleFocus = _useComboboxContext.handleFocus,
    handleBlur = _useComboboxContext.handleBlur,
    handleInputChange = _useComboboxContext.handleInputChange,
    handleKeyDown = _useComboboxContext.handleKeyDown,
    inputRef = _useComboboxContext.inputRef,
    disabled = _useComboboxContext.disabled,
    isInvalid = _useComboboxContext.isInvalid,
    listContainerId = _useComboboxContext.listContainerId,
    isFilteringDisabled = _useComboboxContext.isFilteringDisabled,
    isOptionSelectedOnKeyboardHighlight = _useComboboxContext.isOptionSelectedOnKeyboardHighlight,
    setHighlightedIndex = _useComboboxContext.setHighlightedIndex,
    activeDescendantId = _useComboboxContext.activeDescendantId,
    numberOfOptions = _useComboboxContext.numberOfOptions,
    ariaLabel = _useComboboxContext.ariaLabel,
    ariaLabelledby = _useComboboxContext.ariaLabelledby;
  var _useFormFieldControl = useFormFieldControl(),
    hasLabel = _useFormFieldControl.hasLabel;
  return /*#__PURE__*/React__default.createElement(Input, _extends({}, rest, {
    full: full,
    autoComplete: autoComplete,
    value: inputValue,
    className: classNames(className, styles.comboboxInput, _defineProperty({}, styles.labelledInput, hasLabel)),
    disabled: externalDisabled === undefined ? disabled : externalDisabled,
    invalid: externalInvalid === undefined ? isInvalid : externalInvalid,
    ref: mergeRefs(inputRef, ref),
    onBlur: wrapEvent(onBlur, handleBlur),
    onChange: handleInputChange,
    onFocus: wrapEvent(onFocus, handleFocus),
    onKeyDown: wrapEvent(onKeyDown, handleKeyDown),
    onMouseDown: function onMouseDown(e) {
      return _onMouseDown === null || _onMouseDown === void 0 ? void 0 : _onMouseDown(e);
    },
    onClick: function onClick(e) {
      if (!isOptionSelectedOnKeyboardHighlight && numberOfOptions > 0) {
        setHighlightedIndex(0);
      }
      setIsOpen(true);
      setIsAriaExpanded(true);
      _onClick === null || _onClick === void 0 || _onClick(e);
    },
    role: "combobox",
    "aria-autocomplete": isFilteringDisabled ? 'none' : 'list',
    "aria-expanded": isAriaExpanded,
    "aria-controls": isAriaExpanded ? listContainerId : undefined,
    "aria-activedescendant": activeDescendantId,
    "aria-label": ariaLabelFromProps !== null && ariaLabelFromProps !== void 0 ? ariaLabelFromProps : ariaLabel,
    "aria-labelledby": ariaLabelledbyFromProps !== null && ariaLabelledbyFromProps !== void 0 ? ariaLabelledbyFromProps : ariaLabelledby
  }));
});

export { ComboboxInput as default };
